export const UserType = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  USER: 'User',
} as const;
export type UserType = (typeof UserType)[keyof typeof UserType];
